<div class="page-size" *ngIf="showPageSizeSelector">
  <span>Rows per page:</span>
  <mat-form-field>
    <mat-label></mat-label>
    <mat-select
      [value]="selectedPageSize"
      (selectionChange)="onPageSizeChange($event)"
    >
      <mat-option *ngFor="let item of pageSizeOptions" [value]="item">{{
        item
      }}</mat-option>
    </mat-select>
  </mat-form-field>
</div>
<span class="page-count">{{ pageCount }}</span>
<div class="pages-view">
  <button
    type="button"
    ref="bf"
    title="First Page"
    (click)="goToPage('first')"
  ></button>
  <button
    type="button"
    ref="bp"
    title="Previous Page"
    (click)="goToPage('previous')"
  ></button>
  <span>{{ pagesView }}</span>
  <button
    type="button"
    ref="bn"
    title="Next Page"
    (click)="goToPage('next')"
  ></button>
  <button
    type="button"
    ref="bl"
    title="Last Page"
    (click)="goToPage('last')"
  ></button>
</div>
